import ConfigPROD from "./index.production";
import ConfigDEV from "./index.dev";
import ConfigSTAGING from "./index.staging";

export const Config = ConfigPROD;
